import { Fancybox, Carousel, Panzoom } from "@fancyapps/ui";

(function($){
  console.log('banner-popup.js loaded');
  
  //dom ready
  document.addEventListener("DOMContentLoaded", function(){
    // banner
    $('.newspopup a').click(function(){
      sessionStorage.setItem('visit', '1');
    });

    $('.remove-banner').click(function (event) {
      event.preventDefault();
      sessionStorage.setItem('visit', '1');
      $('.header-top-banner').remove();
    });


    // popup
    Fancybox.bind(".popup-trigger", {
      groupAll : true, // Group all items
      on : {
        ready : (fancybox) => {
          console.log('fancybox #${fancybox.id} is ready!');
        },
        closing : (fancybox) => {
          sessionStorage.setItem('visit', '1');
        },
        "Carousel.Panzoom.click" : (fancybox) => {
          sessionStorage.setItem('visit', '1');
        },
        "*": (event, fancybox, slide) => {
          const sleep = ms => new Promise(r => setTimeout(r, ms));
          console.log('event: ${event}');
        }
      }
    });
    
    // trigger open
    console.log('sessionStorage visit: '+sessionStorage.getItem('visit'));
    let delay = $('.newspopup').data('delay');
    if (!sessionStorage.getItem('visit')) {
      // trigger banner show
      $('.header-top-banner').removeClass('d-none').hide().slideDown(350);
      // trigger popup show
      setTimeout(() => {
        $('.popup-trigger').trigger( "click" );
      }, delay);
    }
  });

})(jQuery);